<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "SchoolStudents",
  data() {
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/my-school/students/excel`,
      uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
      loading: false,
      dataList: [],
      regions: [],
      districts: [],
      schools: [],
      totalElements: 0,
      totalPages: null,
      size: 15,
      page: 1,
      secretForm: {
        board_id: null,
        student_id: null
      },
      uploadForm: {
        board_id: null,
        file: null
      },
      downloadForm: {
        board_id: null
      },
      secretDialogVisible: false,
      uploadDialogVisible: false,
      downloadDialogVisible: false,
      selectedStudent: null,
      boards: [],
      search: null,
      filters: {
        board_id: null,
        region_id: null,
        district_id: null,
        school_id: null
      },
      rules: {
        board_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
      }
    }
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    }
  },
  watch: {
    'filters.board_id'(newVal) {
      this.page = 1;
      this.$router
        .replace({
          query: { ...this.$route.query, board_id: newVal || undefined, page: 1 },
        })
        .catch(() => { });
      this.getRegions()
      // Board o'zgarganda va district tanlangan bo'lsa, school'larni yangilash
      if (this.filters.district_id) {
        this.getSchools();
      }
    },
    'filters.region_id'(newVal) {
      this.page = 1;
      // Region o'zgarganda district va school'ni tozalash
      this.filters.district_id = null;
      this.filters.school_id = null;
      this.districts = [];
      this.schools = [];

      this.$router
        .replace({
          query: {
            ...this.$route.query,
            region_id: newVal || undefined,
            district_id: undefined,
            school_id: undefined,
            page: 1
          },
        })
        .catch(() => { });

      // Region tanlanganda district'larni yuklash
      if (newVal) {
        this.getDistricts(newVal);
      }
    },
    'filters.district_id'(newVal) {
      this.page = 1;
      // District o'zgarganda school'ni tozalash
      this.filters.school_id = null;
      this.schools = [];

      this.$router
        .replace({
          query: {
            ...this.$route.query,
            district_id: newVal || undefined,
            school_id: undefined,
            page: 1
          },
        })
        .catch(() => { });

      // District tanlanganda school'larni yuklash
      if (newVal) {
        this.getSchools();
      }
    },
    'filters.school_id'(newVal) {
      this.page = 1;
      this.$router
        .replace({
          query: { ...this.$route.query, school_id: newVal || undefined, page: 1 },
        })
        .catch(() => { });

      this.getStudents(); // Bu qatorni qo'shish
    }
  },
  methods: {
    onSearch() {
      this.$router.replace({ query: { ...this.$route.query, page: 1 } });
      this.getStudents();
    },
    openUploadModal() {
      this.uploadDialogVisible = true;
      if (!this.boards.length) {
        this.getBoards();
      }
    },
    handleUploadClose() {
      this.uploadDialogVisible = false;
      this.uploadForm = {
        board_id: null,
        file: null
      };
    },
    openDownloadModal() {
      this.downloadDialogVisible = true;
      if (!this.boards.length) {
        this.getBoards();
      }
    },
    handleDownloadClose() {
      this.downloadDialogVisible = false;
      this.downloadForm = {
        board_id: null
      };
    },
    beforeUploadFile(rawFile) {
      if (!rawFile) {
        return false;
      }
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-excel", // .xls
      ];
      if (!allowedTypes.includes(rawFile.type)) {
        ElMessage.error(`Iltimos Excel fayl yuklang! (.xlsx yoki .xls)`);
        return false;
      }
      return true;
    },
    handleFileChange(file) {
      this.uploadForm.file = file.raw;
    },
    submitUpload() {
      this.$refs.uploadForm.validate((valid) => {
        if (valid) {
          if (!this.uploadForm.file) {
            ElMessage.error("Iltimos fayl tanlang!");
            return;
          }

          const formData = new FormData();
          formData.append("file", this.uploadForm.file);
          formData.append("board_id", this.uploadForm.board_id);

          this.loading = true;
          this.$http
            .post(`api/v1/my-school/students/excel`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(() => {
              ElNotification.success({
                message: "Amaliyot muvaffaqiyatli bajarildi!",
              });
              this.getStudents();
              this.handleUploadClose();
            })
            .catch((error) => {
              ElNotification.error({
                message:
                  error.response?.data?.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    submitDownload() {
      this.$refs.downloadForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .get(`api/v1/my-school/students/excel`, {
              params: {
                board_id: this.downloadForm.board_id
              },
              responseType: "blob",
            })
            .then((res) => {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
              );
              const header = res.headers.get("Content-Disposition");
              const parts = header.split(";");
              let fileName = parts[1].split("=")[1];
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.handleDownloadClose();
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Ogohlantirish",
                message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
                type: "warning",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    sendSecretAll() {
      this.secretDialogVisible = true;
      this.getBoards()
    },
    onSend() {
      this.$refs.secretForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http.post("/api/v1/my-school/students/gen-secret", this.secretForm)
            .then(() => {
              ElNotification({
                title: "Tabriklaymiz",
                message: "Muvafaqiyatli yuborildi",
                type: "success",
              });
              this.secretDialogVisible = false
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Xatolik",
                message:
                  response.data.message || "Iltimos, qayta urinib ko'ring.",
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      })
    },
    handleClose() {
      this.secretDialogVisible = false;
      this.secretForm = {
        board_id: null,
        student_id: null,
      }
    },
    sendSecret(student) {
      this.getBoards();
      this.secretDialogVisible = true;
      this.selectedStudent = student;
      this.secretForm.student_id = student.id
    },
    getBoards() {
      this.loading = true
      this.$http
        .get(`api/v1/my-school/boards`, { params: { cache: 'off', offset: 0, limit: 1000 } })
        .then(({ data }) => {
          this.boards = data.boards;
        })
        .catch((err) => {
          ElNotification.error({
            message:
              err.response.data.message ||
              "Doskalar yuklanmadi!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRegions() {
      const board_id = this?.filters?.board_id || this.$route.query.board_id
      this.$http
        .get(`api/v1/my-school/utils/regions`, {
          params: {
            board_id,
            limit: 1000
          }
        })
        .then(({ data }) => {
          this.regions = data.regions;
        })
        .catch((err) => {
          ElNotification.error({
            message: "Viloyatlar yuklanmadi!",
          });
          console.error("regions fetch error", err);
        });
    },
    getDistricts(regionId) {
      const board_id = this.$route.query.board_id || this.filters.board_id
      if (!regionId) return;

      this.loading = true;
      this.$http
        .get(`api/v1/my-school/utils/districts`, {
          params: {
            region_id: regionId,
            board_id
          }
        })
        .then(({ data }) => {
          this.districts = data.districts;
        })
        .catch((err) => {
          ElNotification.error({
            message: "Tumanlar yuklanmadi!",
          });
          console.error("districts fetch error", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSchools() {
      if (!this.filters.district_id) return;

      const boardId = this.$route.query.board_id || this.filters.board_id;

      if (!boardId) {
        ElNotification.warning({
          message: "Iltimos avval doskani tanlang!",
        });
        return;
      }

      this.loading = true;
      this.$http
        .get(`api/v1/my-school/boards/${boardId}/schools`, {
          params: {
            region_id: this.filters.region_id,
            district_id: this.filters.district_id,
            limit: 1000
          }
        })
        .then(({ data }) => {
          this.schools = data.schools;
        })
        .catch((err) => {
          ElNotification.error({
            message: "Maktablar yuklanmadi!",
          });
          console.error("schools fetch error", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.page = 1;
      this.$router
        .replace({
          query: { ...this.$route.query, size: val },
        })
        .then(() => {
          this.getStudents();
        })
        .catch(() => {
        });
    },
    handleCurrentChange(val) {
      this.$router
        .replace({
          query: { ...this.$route.query, page: val },
        })
        .then(() => {
          this.getStudents();
        })
        .catch(() => {
        });
    },
    getStudents() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size
        ? parseInt(this.$route.query.size || "")
        : this.size;

      this.$http
        .get(`api/v1/my-school/students`, {
          params: {
            limit: this.size,
            offset: (this.page - 1) * this.size,
            search: this.search,
            board_id: this.filters.board_id,
            region_id: this.filters.region_id,
            district_id: this.filters.district_id,
            school_id: this.filters.school_id
          },
        })
        .then(({ data }) => {
          this.dataList = data.students;
          this.totalElements = data.count;
        })
        .catch((error) => {
          ElNotification.error({
            message:
              error.response.data.message ||
              "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumoitni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`/api/v1/my-school/students/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Muvaffaqqiyatli o'chirildi",
              });
              this.getStudents();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.size + 1
    }
  },
  mounted() {
    // URL'dan filter qiymatlarini olish
    if (this.$route.query.board_id) {
      this.filters.board_id = parseInt(this.$route.query.board_id);
    }
    if (this.$route.query.region_id) {
      this.filters.region_id = parseInt(this.$route.query.region_id);
      // Region tanlangan bo'lsa, district'larni yuklash
      this.getDistricts(this.filters.region_id);
    }
    if (this.$route.query.district_id) {
      this.filters.district_id = parseInt(this.$route.query.district_id);
      // District tanlangan bo'lsa, school'larni yuklash
      if (this.filters.district_id) {
        this.getSchools();
      }
    }
    if (this.$route.query.school_id) {
      this.filters.school_id = parseInt(this.$route.query.school_id);
    }

    this.getStudents();
    this.getBoards();
    this.getRegions();
  }
}
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-button type="primary" @click="openUploadModal">
          Excel orqali kiritish
        </el-button>
        <el-button type="success" @click="openDownloadModal">
          <img src="@/assets/images/icons/download.svg" alt="" style="margin-right: 5px" />
          O'quvchilarni yuklab olish
        </el-button>
      </div>
      <div style="display: flex;gap:5px">
        <el-button type="success" @click="sendSecretAll">
          Kalit so'zlarni yuborish
        </el-button>
        <el-input v-model="search" style="width: 250px; margin-right: 10px" placeholder="Izlash" clearable
          @clear="onSearch">
          <template #append>
            <el-button style="display: flex" @click="onSearch"><img src="@/assets/images/icons/search.svg" alt="" />
            </el-button>
          </template>
        </el-input>
        <router-link to="school-student/add" class="el-button el-button--primary">
          Qo'shish
        </router-link>
      </div>
    </div>
    <div class="header_bottom">
      <el-select v-model="filters.board_id" placeholder="Doskani tanlang" style="width: 300px" clearable>
        <el-option v-for="board in boards" :key="board.id" :value="board.id" :label="board.title +
          ' ' +
          board.season +
          '-' +
          'mavsum ' +
          board.year +
          ' yil'
          " />
      </el-select>
      <el-select style="width: 300px" placeholder="Viloyatlar" clearable v-model="filters.region_id">
        <el-option v-for="region in regions" :key="region.id" :value="region.id" :label="region.title" />
      </el-select>
      <el-select style="width: 300px" placeholder="Tumanlar" clearable v-model="filters.district_id"
        :disabled="!filters.region_id">
        <el-option v-for="district in districts" :key="district.id" :value="district.id" :label="district.title" />
      </el-select>
      <el-select style="width: 300px" placeholder="Maktablar" clearable v-model="filters.school_id"
        :disabled="!filters.district_id">
        <el-option v-for="school in schools" :key="school.id" :value="school.id" :label="school.title" />
      </el-select>
    </div>
    <el-table :data="dataList" class="table" border height="calc(100vh - 245px)">
      <el-table-column type="index" :index="indexMethod" width="80" label="#" />
      <el-table-column prop="full_name" label="Nomi" min-width="280" />
      <el-table-column prop="phone_number" label="Telefon nomeri" min-width="140" />
      <el-table-column prop="school" label="Maktab nomi" min-width="180" />
      <el-table-column prop="class_name" label="Sinf" min-width="70" />
      <el-table-column prop="kundalik_id" label="Kundalik Id" min-width="140" />
      <el-table-column fixed="right" label="" width="225" align="center">
        <template #default="scope">
          <el-button type="warning" size="small" @click="sendSecret(scope.row)">
            Kalit yuborish
          </el-button>
          <el-button type="primary" size="small" @click="
            $router.push({
              name: 'SchoolStudentFormEdit',
              params: { id: scope.row.id },
            })
            "><img height="15" src="@/assets/images/icons/edit.svg" alt="action" />
          </el-button>
          <el-button type="danger" size="small" @click="onClickDelete(scope.row.id)">
            <img height="15" src="@/assets/images/icons/delete.svg" alt="action" />
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination v-model:current-page="currentPage" class="pagination" @current-change="handleCurrentChange"
            @size-change="handleSizeChange" layout="sizes, prev, pager, next" :total="totalElements"
            v-model:page-size="size" :page-count="totalPages" :background="true"
            :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>

  <!-- Upload Modal -->
  <el-dialog v-model="uploadDialogVisible" title="Excel orqali o'quvchilarni kiritish" width="500"
    :before-close="handleUploadClose">
    <el-form ref="uploadForm" :model="uploadForm" :rules="rules" label-position="top">
      <el-form-item label="Doskani tanlang" prop="board_id">
        <el-select size="large" v-model="uploadForm.board_id" style="width: 100%">
          <el-option v-for="board in boards" :key="board.id" :value="board.id"
            :label="board.title + ' ' + board.season + '-' + 'mavsum ' + board.year + ' yil'" />
        </el-select>
      </el-form-item>
      <el-form-item label="Faylni tanlang">
        <el-upload ref="uploadRef" :auto-upload="false" :on-change="handleFileChange" :before-upload="beforeUploadFile"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :limit="1" :show-file-list="true">
          <el-button type="primary">Fayl tanlash</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleUploadClose">Bekor qilish</el-button>
        <el-button type="primary" @click="submitUpload">
          Yuklash
        </el-button>
      </div>
    </template>
  </el-dialog>

  <!-- Download Modal -->
  <el-dialog v-model="downloadDialogVisible" title="O'quvchilarni yuklab olish" width="500"
    :before-close="handleDownloadClose">
    <el-form ref="downloadForm" :model="downloadForm" :rules="rules" label-position="top">
      <el-form-item label="Doskani tanlang" prop="board_id">
        <el-select size="large" v-model="downloadForm.board_id" style="width: 100%">
          <el-option v-for="board in boards" :key="board.id" :value="board.id"
            :label="board.title + ' ' + board.season + '-' + 'mavsum ' + board.year + ' yil'" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleDownloadClose">Bekor qilish</el-button>
        <el-button type="success" @click="submitDownload">
          Yuklab olish
        </el-button>
      </div>
    </template>
  </el-dialog>

  <!-- Secret Key Modal -->
  <el-dialog v-model="secretDialogVisible"
    :title="selectedStudent?.id ? selectedStudent?.full_name : 'Barcha o\'quvchilarga kalit yuborish'" width="500"
    :before-close="handleClose">
    <el-form ref="secretForm" :model="secretForm" :rules="rules" label-position="top">
      <el-form-item label="Doskani tanlang" prop="board_id">
        <el-select size="large" v-model="secretForm.board_id" style="width: 100%">
          <el-option v-for="board in boards" :key="board.id" :value="board.id"
            :label="board.title + ' ' + board.season + '-' + 'mavsum ' + board.year + ' yil'" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleClose">Bekor qilish</el-button>
        <el-button type="primary" @click="onSend">
          Yuborish
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.header_bottom {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 10px;
}

.filters {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.el-button--primary {
  text-decoration: none;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.pagination-wrapper>span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>